import React, { memo } from 'react';
import './Unbranded404.scss';

const Unbranded404 = memo(() => {
  return (
    <div className="unbranded-404">
      <div className="error-content">
        <div className="error-code">404</div>

        <h1 className="error-title">Page non trouvée</h1>

        <p className="error-description">
          Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
        </p>

        <p className="error-suggestion">Veuillez vérifier l'URL.</p>

        <div className="help-text">
          <p>Besoin d'aide ?</p>
          <p>Contactez le support technique pour toute assistance.</p>
        </div>
      </div>
    </div>
  );
});

Unbranded404.displayName = 'Unbranded404';

export default Unbranded404;
